import { Enum } from '@/base/Enum';

// 评价对象名称
export class suitObjType extends Enum {
  constructor() {
    super();
    this[1] = '物业服务企业';
    this[2] = '项目负责人';
    // this[3]='物业服务企业、项目负责人';
  }
}
// 处罚情形
export class punishmentLevelType extends Enum {
  constructor() {
    super();
    this[1] = '警告并责令整改';
    this[2] = '轻微处罚';
    this[3] = '一般处罚';
    this[4] = '严重处罚';
  }
}

// 状态

export class approveType extends Enum {
  constructor() {
    super();
    this[11] = '待补充资料';
    this[1] = '待受理';
    this[2] = '受理中';
    this[3] = '审核中';
    this[4] = '审核通过';
    this[8] = '已完成';
    this[9] = '已撤销';
    this[10] = '审核不通过';
    // this[99]='其他';
  }
}

// 证件类型
export class certificateType extends Enum {
  constructor() {
    super();
    this[1] = '身份证';
    this[2] = '护照';
    this[4] = '港澳居民来往大陆通行证';
    this[5] = '台湾居民来往大陆通行证';
    this[6] = '其他';
  }
}

// 审核枚举
export class auditStatusEmun extends Enum {
  constructor() {
    super();
    this[1] = '同意';
    this[2] = '不同意';
    this[3] = '退回上一级';
    this[4] = '退回补录';
    this[10] = '撤回';
  }
}

// 审核枚举 - 第二类
export class auditStatusOtherEmun extends Enum {
  constructor() {
    super();
    this[1] = '拟同意';
    this[2] = '拟不同意';
    this[3] = '退回上一级';
    this[4] = '退回补录';
    this[10] = '撤回';
  }
}

//  审批类型
export class AuditTypeCodeEmun extends Enum {
  constructor() {
    super();
    this['SP001'] = '良好信息认定';
    this['SP002'] = '良好信息撤销';
    this['SP003'] = '良好信息删除';
    this['SP004'] = '不良信息认定';
    this['SP005'] = '不良信息撤销';
    this['SP006'] = '不良信息恢复';
    this['SP007'] = '异议处理';
    this['SP008'] = '风险名单认定';
    this['SP009'] = '风险名单撤销';
    this['SP010'] = '风险名单恢复';
    this['SP011'] = '激励名单';
  }
}

// 异议事项类型
export class dissentStatus extends Enum {
  constructor() {
    super();
    this[1] = '良好信息认定';
    this[2] = '良好信息计分';
    this[3] = '不良信息计分';
    this[4] = '风险名单';
    // this[5]='等级评价';
  }
}

// 公示状态
export class publicStatus extends Enum {
  constructor() {
    super();
    this[1] = '正常';
    this[2] = '已到期';
    this[3] = '废弃';
  }
}

//  学历枚举
export class educationEnum extends Enum {
  constructor() {
    super();
    this[3] = '高中及其以下学历';
    this[2] = '中专';
    this[4] = '大专';
    this[5] = '本科';
    this[6] = '硕士研究生';
    this[7] = '博士研究生';
  }
}
